<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">7. Total de leitos</div>
    <div v-if="!loading">
      <unicom-linha
        style="padding: 16px; padding-left: 24px"
        :espacamento="false"
        v-for="(info, index) in arrayInformacoes"
        :key="index"
        :class="{ par: index % 2 === 0 }"
      >
        <unicom-coluna
          sm="auto"
          md="6"
          :class="$breakpoint.smAndDown ? 'mr-3' : ''"
        >
          <div class="medio">{{ info.nome }}:</div>
        </unicom-coluna>
        <unicom-coluna sm="auto" md="6">
          <div class="medio">{{ info.quantidade }}</div>
        </unicom-coluna>
      </unicom-linha>
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      v-show="loading"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "TotalLeitos",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      arrayInformacoes: [
        // {
        //   nome: "",
        //   quantidade: 0
        // }
      ]
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getLeitos(this.idRnpPrestador)
          .then(res => {
            this.arrayInformacoes = res.data;
            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  },
  computed: {
    objetoInformacoesComputed() {
      return Object.entries(this.objetoInformacoes);
    }
  }
};
</script>

<style>
.par {
  background: #f2f5f4;
}
</style>
